export default __webpack_public_path__ + "static/media/poster.6fbdda13.jpeg";